// Tiny Web-Audio sound cues for the live auction (no audio files shipped).
// Two cues: a bright "blip" when you place a bid, and a lower alert when you
// get outbid. The AudioContext is created lazily and resumed on a user gesture
// (browsers block audio until the user interacts), so the first bid click also
// unlocks the outbid sound that arrives later over the socket.

let ctx = null;

function getCtx() {
    if (typeof window === "undefined") return null;
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    try {
        if (!ctx) ctx = new AC();
        if (ctx.state === "suspended") ctx.resume().catch(() => {});
        return ctx;
    } catch (e) {
        return null;
    }
}

// A single enveloped tone starting `start` seconds from now.
function tone(c, freq, start, dur, type = "sine", gain = 0.16) {
    const osc = c.createOscillator();
    const g = c.createGain();
    osc.type = type;
    osc.frequency.value = freq;
    osc.connect(g);
    g.connect(c.destination);
    const t0 = c.currentTime + start;
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(gain, t0 + 0.012);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    osc.start(t0);
    osc.stop(t0 + dur + 0.03);
}

// Call from a user gesture to unlock audio ahead of time.
export function unlockAudio() { getCtx(); }

// Rising two-note "blip" — your bid landed.
export function playBid() {
    const c = getCtx();
    if (!c) return;
    tone(c, 660, 0, 0.12, "triangle", 0.18);
    tone(c, 988, 0.085, 0.14, "triangle", 0.18);
}

// Lower, slightly dissonant double-beep — you've been outbid.
export function playOutbid() {
    const c = getCtx();
    if (!c) return;
    tone(c, 392, 0, 0.16, "sawtooth", 0.13);
    tone(c, 294, 0.17, 0.26, "sawtooth", 0.15);
}
